import React, { useEffect, useState } from "react"
import Breadcrumb from "components/Common/Breadcrumb"
import { Card, CardBody, Row, Col, Input, Button } from "reactstrap"
import { Map, TileLayer, Polyline, Marker, Popup } from "react-leaflet"
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import {
  FaLocationDot,
  FaLocationPin,
  FaLocationPinLock,
} from "react-icons/fa6"
import { fetchData, FetchPostData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/Loader"
import { FaRoute } from "react-icons/fa"

// Fix marker icon
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
})

const LocationTracking = () => {
  const [employee, setEmployee] = useState("")
  const [date, setDate] = useState("")
  const [route, setRoute] = useState([])

  const [loading, setLoading] = useState(false)
  const [employees, setEmployees] = useState([])

  useEffect(() => {
    getEmployees()
  }, [])

  async function getEmployees() {
    const APIdata = await fetchData(setLoading, "users")
    if (APIdata?.success) {
      setEmployees(APIdata?.data)
    }
  }

  const fetchLocationData = async () => {
    const APIdata = await FetchPostData(
      setLoading,
      "attendance/user/route/by/date",
      {
        userId: employee,
        date,
      }
    )
    if (APIdata?.data?.success) {
      console.log(APIdata?.data?.data?.polyline)
      setRoute(APIdata?.data?.data?.polyline)
    } else {
      Swal.fire({
        title: "Error fetching Route",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb
        title="Employee Tracking"
        breadcrumbItem="Location Tracking"
      />

      <Card className="mb-3">
        <CardBody>
          <Row>
            <Col md={2}>
              <Input
                type="select"
                className="rounded-4"
                onChange={e => setEmployee(e.target.value)}
              >
                <option value="">Select Employee</option>
                {employees?.map((item, index) => (
                  <option value={item?.id} key={index}>
                    {item?.name}
                  </option>
                ))}
              </Input>
            </Col>

            <Col md={2}>
              <Input
                type="date"
                className="rounded-4"
                onChange={e => setDate(e.target.value)}
              />
            </Col>

            <Col md={2}>
              <Button
                className="btn-blue rounded-4 px-3 text-nowrap"
                block
                disabled={!employee || !date}
                onClick={fetchLocationData}
              >
                <FaRoute /> Track Route
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {route?.length > 0 ? (
        <Card>
          <CardBody style={{ height: "600px" }}>
            <Map
              center={route[0]}
              zoom={14}
              style={{ height: "100%", width: "100%" }}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

              <Polyline positions={route} color="blue" />

              <Marker position={route[0]}>
                <Popup>Start Location</Popup>
              </Marker>

              <Marker position={route[route.length - 1]}>
                <Popup>End Location</Popup>
              </Marker>
            </Map>
          </CardBody>
        </Card>
      ): (<div className="text-center">No route found</div>)}
    </div>
  )
}

export default LocationTracking
